import { Container, Image, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { FaRightFromBracket, FaUser } from 'react-icons/fa6';
import { NavLink } from 'react-router-dom';
import { useApp } from 'common/AppContext';

import gmetrix_logo_white from 'common/assets/logo_gmetrix_white.png';

import './AppNav.css';

// Brand navy. The bootswatch theme exposes this as $bg-theme-nav-primary;
// react-bootstrap's bg-primary uses $primary (brand blue), so we set the
// background explicitly here. Pair it with data-bs-theme="dark" so all
// nav text + dropdowns invert their colors via Bootstrap 5.3 color modes —
// the legacy `variant="dark"` is a no-op against this stylesheet.
const NAVY = '#003366';

export const AppNav = () => {

    const { logout, user } = useApp();

    return (

        <Navbar
            collapseOnSelect
            className="qa-hub-navbar shadow-sm"
            expand="md"
            sticky="top"
            style={{ backgroundColor: NAVY }}
        >

            <Container fluid className="px-3">

                <Navbar.Brand
                    exact
                    as={NavLink}
                    className="d-flex align-items-center me-4 py-0"
                    to="/"
                >
                    <Image
                        alt="GMetrix"
                        src={gmetrix_logo_white}
                        style={{ height: 24, objectFit: 'contain', width: 'auto' }}
                    />
                    <span
                        style={{
                            borderLeft: '1px solid rgba(255, 255, 255, 0.25)',
                            fontSize: 16,
                            letterSpacing: 0.3,
                            lineHeight: 1
                        }}
                        className="ms-3 ps-3 fw-light text-white"
                    >
                        QA Hub
                    </span>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="qa-hub-nav" />

                <Navbar.Collapse id="qa-hub-nav">

                    <Nav className="me-auto">

                        <Nav.Link
                            exact
                            activeClassName="active"
                            as={NavLink}
                            to="/"
                        >
                            Home
                        </Nav.Link>

                        <Nav.Link
                            activeClassName="active"
                            as={NavLink}
                            to="/feature-tester"
                        >
                            Feature Tester
                        </Nav.Link>

                        <NavDropdown id="qa-hub-testrail-dropdown" title="TestRail">
                            <NavDropdown.Item as={NavLink} to="/testrail/runs">
                                Open Test Runs
                            </NavDropdown.Item>
                            <NavDropdown.Item exact as={NavLink} to="/testrail/cases">
                                Browse Test Cases
                            </NavDropdown.Item>
                            <NavDropdown.Item as={NavLink} to="/testrail/cases/new">
                                Create a Test Case
                            </NavDropdown.Item>
                        </NavDropdown>

                        <Nav.Link
                            activeClassName="active"
                            as={NavLink}
                            to="/azure-devops"
                        >
                            Azure DevOps
                        </Nav.Link>

                        <Nav.Link
                            activeClassName="active"
                            as={NavLink}
                            to="/usage"
                        >
                            Usage
                        </Nav.Link>

                        {user && user.isAdmin && (
                            <NavDropdown id="qa-hub-admin-dropdown" title="Admin">
                                <NavDropdown.Item as={NavLink} to="/admin/users">
                                    Users
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink} to="/admin/apps">
                                    Apps & Environments
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink} to="/admin/settings">
                                    Settings
                                </NavDropdown.Item>
                            </NavDropdown>
                        )}

                    </Nav>

                    {user && (
                        <Nav>
                            <NavDropdown
                                title={(
                                    <span className="d-inline-flex align-items-center gap-2">
                                        <FaUser size={12} />
                                        <span>
                                            {user.displayName || 'Account'}
                                        </span>
                                    </span>
                                )}
                                align="end"
                                id="qa-hub-user-dropdown"
                            >
                                {user.email && (
                                    <>
                                        <div className="px-3 py-2 text-muted" style={{ fontSize: 12 }}>
                                            {user.email}
                                        </div>
                                        <NavDropdown.Divider className="my-1" />
                                    </>
                                )}
                                <NavDropdown.Item onClick={logout}>
                                    <FaRightFromBracket className="me-2" size={12} />
                                    Sign out
                                </NavDropdown.Item>
                            </NavDropdown>
                        </Nav>
                    )}

                </Navbar.Collapse>

            </Container>

        </Navbar>

    );

};
